import http from "./apiServices"

export const getServiceLinesById = (serviceId) => {
  return http.get(`services/${serviceId}/lines`)
}

export const putServiceLinesById = ({ serviceId, lineInfo }) => {
  return http.put(`services/${serviceId}/lines`, lineInfo)
}
